/* Email capture popup.

   Three rules decide almost everything here.

   It must not nag. Once someone closes it or hands over an address, that
   decision is remembered and the popup never appears to them again. The
   alternative — reappearing every page load — costs more in goodwill than a
   10% code is worth.

   It must not fire before the visitor has seen anything. It waits for a delay,
   or for the mouse to leave toward the tab bar, whichever happens first.

   And the code must never be revealed unless the address was really captured.
   An earlier version posted to Shopify's customer form, which turned out to be
   unusable here twice over: the bot challenge navigates the whole page away
   from the popup, and when it is posted any other way Shopify rejects it
   outright with "Missing CAPTCHA token". So the address goes to our own API
   instead, which answers in JSON, and the code is shown only on a real 2xx.
   A failure says so and keeps the address on screen to retry.
*/
(function () {
  var KEY = "bht_pop_v1"; // "closed" | "joined", survives the browser

  function remembered() {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  }
  function remember(v) {
    try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ }
  }

  function init() {
    var pop = document.getElementById("bht-pop");
    if (!pop) return;

    var card = pop.querySelector(".bht-pop__card");
    var form = pop.querySelector("form");
    var ask = pop.querySelector('[data-bht-pop-step="ask"]');
    var done = pop.querySelector('[data-bht-pop-step="done"]');
    var lastFocus = null;
    var timer = null;
    var openedAt = 0; // when the popup appeared, for the minimum-fill-time check

    function open(step) {
      if (pop.dataset.open === "1") return;
      pop.dataset.open = "1";
      lastFocus = document.activeElement;
      pop.hidden = false;
      openedAt = Date.now();
      if (step === "done") showDone();
      // Two frames: the hidden state has to paint before the transition has a
      // value to animate from. Same reason the scroll reveals need it.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          pop.classList.add("is-open");
          (card || pop).focus();
        });
      });
      document.addEventListener("keydown", onKey);
    }

    function close() {
      pop.classList.remove("is-open");
      pop.dataset.open = "";
      document.removeEventListener("keydown", onKey);
      window.setTimeout(function () {
        pop.hidden = true;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }, 280);
      if (remembered() !== "joined") remember("closed");
    }

    function onKey(e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var items = pop.querySelectorAll(
        'a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'
      );
      var vis = Array.prototype.filter.call(items, function (el) {
        return el.offsetParent !== null;
      });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function showDone() {
      if (ask) ask.hidden = true;
      if (done) done.hidden = false;
      remember("joined");
    }

    pop.querySelectorAll("[data-bht-pop-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });

    var copyBtn = pop.querySelector("[data-bht-pop-copy]");
    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = (pop.querySelector("[data-bht-pop-code]") || {}).textContent || "";
        var label = pop.querySelector("[data-bht-pop-copied]");
        var say = function (t) {
          if (!label) return;
          label.textContent = t;
          window.setTimeout(function () { label.textContent = "Copy"; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code.trim()).then(
            function () { say("Copied"); },
            function () { say("Select it"); }
          );
        } else {
          say("Select it");
        }
      });
    }

    if (form) {
      var err = pop.querySelector("[data-bht-pop-err]");
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent.trim() : "Reveal my code";

      function fail(msg) {
        if (err) { err.textContent = msg; err.hidden = false; }
        if (btn) { btn.disabled = false; btn.textContent = label; }
      }

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="email"]');
        var value = input ? input.value.trim() : "";
        if (!value || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
          fail("That email doesn't look right.");
          if (input) input.focus();
          return;
        }
        if (err) err.hidden = true;
        if (btn) { btn.disabled = true; btn.textContent = "One sec…"; }

        var hp = form.querySelector('input[name="website"]');
        var body = {
          email: value,
          code: pop.getAttribute("data-code") || "",
          elapsed: openedAt ? Date.now() - openedAt : 0,
          website: hp ? hp.value : "",
          consent: "Submitted the storefront discount popup to reveal a code."
        };

        fetch(pop.getAttribute("data-endpoint"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            // Only a real 2xx reveals the code. Anything else and the address
            // may not have been saved, so saying "done" would be a lie.
            if (!res.ok) throw new Error("save failed: " + res.status);
            showDone();
          })
          .catch(function () {
            fail("Couldn't save that just now — try again?");
          });
      });
    }

    if (remembered()) return; // closed or already joined — never again

    var delay = parseInt(pop.getAttribute("data-delay") || "12", 10) * 1000;
    timer = window.setTimeout(function () { open("ask"); }, delay);

    document.addEventListener("mouseout", function onOut(e) {
      if (e.clientY > 0 || e.relatedTarget || remembered()) return;
      window.clearTimeout(timer);
      document.removeEventListener("mouseout", onOut);
      open("ask");
    });
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
